import { CardSelectOption } from "ui/components/CardSelect";

// Prikaz lokacije na karti — dvije isključive opcije, isti obrazac kao
// "Cijena uključuje troškove uvoza" u koraku Cijena.
export const LOCATION_DISPLAY_OPTIONS: CardSelectOption[] = [
  {
    id: "exact",
    icon: "/media/icons/location.svg",
    title: "Točna lokacija",
    description: "Na karti se prikazuje točna adresa vozila.",
  },
  {
    id: "approximate",
    icon: "/media/icons/location.svg",
    title: "Približna lokacija",
    description: "Na karti se prikazuje samo šire područje.",
  },
];
